export default __webpack_public_path__ + "static/flag-dark-mode-c8066cbf6de643d6d05d9170ab27df85.png";